import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/styles";
import Navbar from "../Components/Common/newNavbar/Navbar";
import { Container } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  box: {
    backgroundColor: theme.palette.primary.main,
    minHeight: "calc(100vh - 98px)",
  },
}));

const Layout = (props) => {
  const classes = useStyles();

  return (
    <Navbar>
      <main style={{ height: "100%" }}>{props.children}</main>
    </Navbar>
  );
};

export default Layout;
